import api from './api';

interface PrecoData {
  grupo_id: number;
  produto_id: number;
  preco: number;
}

const newProdutoPreco = async ({
  grupo_id,
  produto_id,
  preco,
}: PrecoData): Promise<void> => {
  await api.post('/produto/preco', {
    grupo_id,
    produto_id,
    tabela_preco_id: 1,
    valor: preco,
  });
};

export default newProdutoPreco;
